import { render, staticRenderFns } from "./PrivateMenu.vue?vue&type=template&id=263d2b9e&scoped=true"
import script from "./PrivateMenu.vue?vue&type=script&lang=js"
export * from "./PrivateMenu.vue?vue&type=script&lang=js"
import style0 from "./PrivateMenu.vue?vue&type=style&index=0&id=263d2b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d2b9e",
  null
  
)

export default component.exports